import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { InternalGuard } from './guards/internal.guard';

import { ErrorComponent } from './components/error/error.component';

import { LoginComponent } from './components/consultant/login/login.component';
import { BoardingConsultantComponent } from './components/consultant/boarding-consultant/boarding-consultant.component';
import { CandidatesComponent } from './components/consultant/candidates/candidates.component';
import { CreateCandidateComponent } from './components/consultant/create-candidate/create-candidate.component';
import { UploadCandidatesComponent } from './components/consultant/upload-candidates/upload-candidates.component';
import { ProcessesComponent } from './components/consultant/processes/processes.component';
import { ProcessCreateComponent } from './components/consultant/process-create/process-create.component';
import { ProcessDetailComponent } from './components/consultant/process-detail/process-detail.component';
import { HistoryCandidatesComponent } from './components/consultant/history/history.component';
import { ReportsCtComponent } from './components/consultant/reports-ct/reports-ct.component';
import { IdealProfilesComponent } from './components/consultant/ideal-profiles/ideal-profiles.component';
import { IdealProfileDetailComponent } from './components/consultant/ideal-profile-detail/ideal-profile-detail.component';
import { TestSearchComponent } from './components/consultant/test-search/test-search.component';

import { HomeComponent } from './components/candidate/common/home/home.component';

import { EvalualiaReportComponent } from './components/report/evalualia-report/evalualia-report.component';
import { MindsetReportComponent } from './components/report/mindset-report/mindset-report.component';
import { CtReportComponent } from './components/report/ct-report/ct-report.component';
import { TestComponent } from './components/candidate/test/test.component';
import { VersionComponent } from './components/version/version.component';
import { PlatformLocation } from '@angular/common';
import { PrivacyComponent } from './components/candidate/legal/privacy/privacy.component';
import { LegalTermsComponent } from './components/candidate/legal/legal-terms/legal-terms.component';

const consultantRoutes: Routes = [
  {
    path: 'consultant/login',
    component: LoginComponent,
  },
  {
    path: 'consultant/boarding',
    component: BoardingConsultantComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/tests',
    component: TestSearchComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/processes',
    component: ProcessesComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/processes/create',
    component: ProcessCreateComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/processes/edit/:id',
    component: ProcessDetailComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/processes/show/:id',
    component: ProcessDetailComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/candidates',
    component: CandidatesComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/candidates/create',
    component: CreateCandidateComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/candidates/upload',
    component: UploadCandidatesComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/candidates/history/:candidateId',
    component: HistoryCandidatesComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/reports/invitation/:invitationId/test/:testId',
    component: ReportsCtComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/reports-ct/invitation/:invitationId/test/:testId',
    component: ReportsCtComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/profiles',
    component: IdealProfilesComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/profiles/detail/:profileId',
    component: IdealProfileDetailComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/profiles/edit/:profileId',
    component: IdealProfileDetailComponent,
    canActivate: [InternalGuard]
  },
  {
    path: 'consultant/profiles/create',
    component: IdealProfileDetailComponent,
    canActivate: [InternalGuard]
  }
];

const candidateRoutes: Routes = [
  {
    path: 'candidate/home/:token',
    component: HomeComponent,
  },
  {
    path: 'candidate/test/:token',
    component: TestComponent,
  },
  {
    path: 'candidate/terms/privacy',
    component: PrivacyComponent
  },
  {
    path: 'candidate/terms/legal',
    component: LegalTermsComponent
  },
];

const routes: Routes = [
  {
    path: '',
    component: BoardingConsultantComponent,
    canActivate: [InternalGuard]
  },
  ...consultantRoutes,
  ...candidateRoutes,
  {
    path: 'report/evalualia/:token',
    component: EvalualiaReportComponent
  },
  {
    path: 'report/md/:token',
    component: MindsetReportComponent
  },
  {
    path: 'report/ct/:token',
    component: CtReportComponent
  },
  {
    path: 'error/:type',
    component: ErrorComponent
  },
  {
    path: 'app/version',
    component: VersionComponent
  },
  {
    path: '**',
    redirectTo: '/error/not-found'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, initialNavigation: 'disabled' })],
  exports: [RouterModule],
  providers: [InternalGuard]
})
export class AppRoutingModule {
  private urlParams = {};
  module: string;

  constructor(
    private platformLocation: PlatformLocation,
    private router: Router) {
    this.handleRouting();
  }

  // Manejamos las rutas manualmente por tener HashLocationStrategy configurado y hacerlo compatible para el nuevo login de Google.
  private handleRouting() {

    if (this.isLoginSuccessHash(this.platformLocation.hash)) {

      this.splitUriFragment(this.platformLocation.hash.replace('#', ''));

      let googleCredentialResponse = JSON.parse(
        sessionStorage.getItem('google_credential_response')
      );

      sessionStorage.setItem(
        'googleAuth',
        JSON.stringify({
          ...googleCredentialResponse,
          ...this.urlParams
        })
      );

      sessionStorage.setItem('googleToken', JSON.parse(sessionStorage.getItem('googleAuth')).access_token);
      sessionStorage.setItem('basicProfileMail', JSON.parse(sessionStorage.getItem('googleAuth')).id_token);
      sessionStorage.setItem('hostedDomain', JSON.parse(sessionStorage.getItem('googleAuth')).hd);

      sessionStorage.removeItem('google_credential_response');
      this.router.navigate(['/consultant/login']);

    } else if (this.platformLocation.hash.length > 0) {
      // Logica para redirigir cuando la ruta trae parametros. Ej: ...?lang=ES
      this.splitUriFragment(this.platformLocation.hash.replace('#', '').split('?')[1]);
      this.router.navigate(
        [this.platformLocation.hash.replace('#', '').split('?')[0]], { queryParams: this.urlParams });
    } else {
      // Logica para redirigir cuando la ruta NO trae parametros. Ej: ...?lang=ES
      this.router.navigate(['/']);
    }

  }

  // Obtenemos los fragmentos de la URL y los pasamos como queryparams al localstorage
  private splitUriFragment(fragment: string) {
    const regex = /([^&=]+)=([^&]*)/g;
    let m;
    while ((m = regex.exec(fragment))) {
      this.urlParams[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }
  }

  // Comprobamos si el hash es correcto para evitar brechas de seguridad.
  private isLoginSuccessHash(hash: string): boolean {

    const params: string[] = ['expires_in', 'scope', 'state'];

    const searchParams = params.filter(param => hash.indexOf(param) > -1);

    return params.length === searchParams.length;

  }
}
